import { useIsMobile } from '@client/hooks/dom.hooks';

interface HideProps {
  readonly mdUp?: boolean;
  readonly mdDown?: boolean;
  readonly children: React.ReactNode;
}

export const Hide: React.FC<HideProps> = ({ mdUp = false, mdDown = false, children }) => {
  const isMobile = useIsMobile();

  if (mdUp && !isMobile) {
    return null;
  }

  if (mdDown && isMobile) {
    return null;
  }

  return (
    <>
      {children}
    </>
  );
};
